import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Layout, Row, Col } from "antd";
import HeaderSearch from "./HeaderSearch";
import HeaderUser from "./HeaderUser";
import MenuLogo from "../menu/logo";

const { Header } = Layout;

export default function HeaderHorizontal() {
  const customise = useSelector((state) => state.customise);
  const [headerClass, setHeaderClass] = useState("");
  const inputFocusRef = useRef(null);

  useEffect(() => {
    if (customise.navigationFull) setHeaderClass(" hp-header-full");
    else if (customise.navigationBg) setHeaderClass(" hp-header-bg");
    else setHeaderClass("");
  }, [customise]);

  return (
    <Header className={`hp-header-horizontal oekfb-admin-header${headerClass}`}>
      <Row className="oekfb-admin-header__row" align="middle" wrap={false}>
        <Col flex="none" className="oekfb-admin-header__brand">
          <MenuLogo to="/admin" />
        </Col>
        <Col flex="auto" className="hp-header-search oekfb-admin-header__search">
          <HeaderSearch inputFocusProp={{ ref: inputFocusRef }} setSearchHeader={() => {}} />
        </Col>
        {/* Language, notifications and template profile controls are intentionally hidden for now. */}
        <Col flex="none" className="oekfb-admin-header__user"><HeaderUser /></Col>
      </Row>
    </Header>
  );
}
